import { useState } from 'react';
import { faqs } from '@/mocks/homeData';
import type { Faq } from '@/pages/home/types';

const list = faqs as Faq[];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto w-full max-w-4xl">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-sm text-secondary-700">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">关于这份榜单你可能想问</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            下面是浏览时最常被问到的几个问题，点开即可查看说明。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {list.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-lg border border-background-200/80 bg-background-100/50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                >
                  <span className="text-sm text-foreground-950 md:text-base">{item.q}</span>
                  <span
                    className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-full transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-4 pb-4 md:px-5 md:pb-5">
                    <p className="border-t border-background-200 pt-3 text-xs leading-relaxed text-foreground-600 md:text-sm">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}